/**
 * Walk a section's ancestor chain into a display path (root → leaf), e.g.
 * ["Backend", "Auth"]. Works for any section shape via the `getInfo` resolver
 * (shared sections use parentSectionId; personal sections use
 * parentPersonalSectionId). Cycle-guarded. Empty array for an unsorted task.
 */
export function buildSectionPath(
  sectionId: string | null,
  getInfo: (id: string) => { name: string; parentId: string | null } | undefined,
): string[] {
  if (!sectionId) return [];
  const names: string[] = [];
  const seen = new Set<string>();
  let cur: string | null = sectionId;
  while (cur && !seen.has(cur)) {
    seen.add(cur);
    const info = getInfo(cur);
    if (!info) break;
    names.unshift(info.name);
    cur = info.parentId;
  }
  return names;
}
